import type { FieldError, UseFormRegisterReturn } from 'react-hook-form'

import { useEffect, useRef } from 'react'

import { ErrorText, SimpleInput } from '#components/controls/input'
import { InputContainer } from '#components/shared/styles'

interface EmailInputProps {
  register: UseFormRegisterReturn
  error?: FieldError
  emailError?: string | null
  disabled?: boolean
  onFocus?: () => void
  onBlur?: () => void
}

export const EmailInput = ({
  register,
  error,
  emailError,
  disabled = false,
  onFocus,
  onBlur,
}: EmailInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const wasDisabledRef = useRef(disabled)

  const { ref: registerRef, ...registerProps } = register

  useEffect(() => {
    if (wasDisabledRef.current && !disabled && inputRef.current) {
      inputRef.current.focus()
    }
    wasDisabledRef.current = disabled
  }, [disabled])

  const displayError = error?.message || emailError

  return (
    <InputContainer>
      <SimpleInput
        ref={(el) => {
          inputRef.current = el
          registerRef(el)
        }}
        type="email"
        label="Work email"
        placeholder="name@company.com"
        onFocus={onFocus}
        data-testid="email-input"
        aria-invalid={Boolean(displayError)}
        {...registerProps}
        onBlur={onBlur}
        disabled={disabled}
        autoFocus={!disabled}
        autoComplete="email"
        required
      />
      {displayError && (
        <ErrorText
          data-testid="email-input-error"
          error={displayError}
          className="mt-1.5"
        />
      )}
    </InputContainer>
  )
}
